export { ClickAwayListener as default } from "./ClickAwayListener.mjs";